import { Component, Input } from '@angular/core';
import {
  DsButtonVariants,
  DsColors,
  DsLoadingSpinnerSize,
  DsLoadingSpinnerVariant,
  Icons,
  IconScale,
  IconStyles,
} from '@levelaccess/design-system';
import { Api } from '../../../../shared/constants/api';
import { FeatureFlagCollection, revertFlag } from '../../../../shared/interfaces/feature-flag.interface';

export enum pageLoadingState {
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
}

@Component({
  selector: 'app-page-loading-state',
  templateUrl: './page-loading-state.component.html',
  styleUrls: ['./page-loading-state.component.scss'],
  standalone: false,
})
export class PageLoadingStateComponent {
  @Input() loadingState: pageLoadingState;

  public Api: typeof Api;
  public pageLoadingState: typeof pageLoadingState;
  public DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public DsColors: typeof DsColors = DsColors;
  public DsLoadingSpinnerSize: typeof DsLoadingSpinnerSize = DsLoadingSpinnerSize;
  public DsLoadingSpinnerVariant: typeof DsLoadingSpinnerVariant = DsLoadingSpinnerVariant;
  public Icons: typeof Icons = Icons;
  public IconScale: typeof IconScale = IconScale;
  public IconStyles: typeof IconStyles = IconStyles;
  public FeatureFlagCollection: typeof FeatureFlagCollection = FeatureFlagCollection;
  public revertFlag: typeof revertFlag = revertFlag;

  constructor() {
    this.pageLoadingState = pageLoadingState;
    this.Api = Api;
  }

  public reloadPage(): void {
    window.location.reload();
  }
}
